import { useMemo } from 'react';
import { TreeViewProps } from '@material-ui/lab';

import {
  STreeNodeLabel,
  STree,
  STreeLoader,
  SEmptyState
} from '@setvi/shared/components';
import { Breadcrumb, Category } from 'Services/Mongo/Types';
import { NoResultIcon } from 'pages/admin/pages/resources/components/icons';

import { useCategories } from './useCategories';

interface CategoriesProps {
  onSelectCategory: (category: Category) => void;
  expandedCategories?: Breadcrumb[];
  selectedCategory: Category;
  treeViewProps?: TreeViewProps;
  search?: string;
}

export const Categories = ({
  onSelectCategory,
  expandedCategories,
  selectedCategory,
  treeViewProps,
  search
}: CategoriesProps) => {
  const { categories, isLoading, searchCategories } = useCategories();

  const filteredCategories = useMemo(
    () => searchCategories(categories, search),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [categories, search]
  );

  if (isLoading) return <STreeLoader />;

  if (filteredCategories?.length === 0 && !isLoading)
    return (
      <SEmptyState
        svg={<NoResultIcon />}
        subTitle={`No Categories ${search ? 'Found' : 'Available'} `}
      />
    );

  return (
    <STree
      nodes={filteredCategories}
      selected={selectedCategory}
      // eslint-disable-next-line no-underscore-dangle
      keyGetter={category => category?._id}
      // eslint-disable-next-line no-underscore-dangle
      treeViewProps={{
        expanded: expandedCategories?.map(c => c._id),
        ...treeViewProps
      }}
      nodeChildrenGetter={category => category.children}
      onNodeClick={onSelectCategory}
      renderNodeLabel={category => (
        <STreeNodeLabel
          item={category}
          title={category?.name}
          search={search}
          selected={selectedCategory?._id === category?._id}
        />
      )}
    />
  );
};
